import { useState } from 'react';
import type { CirightProfile } from '../lib/auth';
import { fallbackGradient, initials } from '../lib/format';

export function Avatar({ profile, size }: { profile: CirightProfile; size: number }) {
  const [failed, setFailed] = useState(false);
  const showPhoto = Boolean(profile.photo) && !failed;
  return (
    <span
      aria-hidden="true"
      className="relative flex shrink-0 items-center justify-center overflow-hidden rounded-full font-semibold tracking-tight text-white"
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.4),
        background: fallbackGradient(profile.name),
      }}
    >
      {showPhoto && profile.photo ? (
        <img
          src={profile.photo}
          alt=""
          className="absolute inset-0 h-full w-full object-cover"
          onError={() => setFailed(true)}
        />
      ) : (
        initials(profile.name)
      )}
      <span className="pointer-events-none absolute inset-0 rounded-full ring-1 ring-inset ring-black/10" />
    </span>
  );
}
